export const maxPodSize = 5;
export const maxPodAutoFill = 3;

export const sectionSize = 100; // the number of audience members in a section
export const numColumns = 5; // the number of columns in the audience. where one
// column contains one pod of seats
// should be even to allow a middle aisle
